import {ethers} from "ethers";
import {UniswapV2FactoryAbi} from "@/abi/UniswapV2FactoryAbi";
import {UniswapV2Router02Abi} from "@/abi/UniswapV2Router02Abi";
import {
    PairAddress,
    PancakeSwapFactoryAddress,
    PancakeSwapRouterAddress, PreSaleAddress,
    TokenAddress,
    UsdtAddress
} from "@/utils/const";
import {IERC20ABI} from "@/abi/IERC20ABI";
import {PairAbi} from "@/abi/PairAbi";
import {PreSaleABI} from "@/abi/PreSaleABI";

const rpc_url = "https://orbital-patient-spring.bsc.quiknode.pro/86b37897652be92c6ab9fe89c94a4ed6bfbffcf0/";


export const default_provider = new ethers.JsonRpcProvider(rpc_url);

export const default_pancake_factory_contract = new ethers.Contract(PancakeSwapFactoryAddress, UniswapV2FactoryAbi, default_provider);
export const default_pancake_router_contract = new ethers.Contract(PancakeSwapRouterAddress, UniswapV2Router02Abi, default_provider);

export const default_token_contract = new ethers.Contract(TokenAddress, IERC20ABI, default_provider);
export const default_pair_contract = new ethers.Contract(PairAddress, PairAbi, default_provider);


export function getUsdtContract(signer) {
    const usdt_contract = new ethers.Contract(UsdtAddress, IERC20ABI, signer);
    return usdt_contract
}

export function getPreSellContract(signer){
    return new ethers.Contract(PreSaleAddress, PreSaleABI, signer)
}